const prepareChannels = channels => channels.filter(c => !!c).join('+') || undefined;
export default prepareChannels;